export const ACTION_SET_IS_AUTH = "ACTION_SET_IS_AUTH"
export const ACTION_SET_USER_DATA = "ACTION_SET_USER_DATA"